// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hy-annotation-no-end-time{display:inline}
`, "",{"version":3,"sources":["webpack://./src/components/editors/UXEditor/AnnotationEditor/Time/index.scss"],"names":[],"mappings":"AAAA,2BACI,cAAe","sourcesContent":[".hy-annotation-no-end-time {\n    display: inline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
